var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7898 5.93212C11.7432 5.92545 11.6965 5.92545 11.6498 5.93212C10.6165 5.89878 9.79651 5.05212 9.79651 4.01212C9.79651 2.95212 10.6565 2.08545 11.7232 2.08545C12.7832 2.08545 13.6498 2.94545 13.6498 4.01212C13.6432 5.05212 12.8232 5.89878 11.7898 5.93212Z",
    fill: "#CE6300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9633 10.5521C13.2166 11.0521 12.1699 11.2388 11.2033 11.1121C11.4566 10.5655 11.5899 9.9588 11.5966 9.3188C11.5966 8.65213 11.4499 8.0188 11.1699 7.46546C12.1566 7.33213 13.2033 7.5188 13.9566 8.0188C15.0099 8.71213 15.0099 9.85213 13.9633 10.5521Z",
    fill: "#CE6300"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.39642 5.93212C4.44309 5.92545 4.48976 5.92545 4.53642 5.93212C5.56976 5.89878 6.38976 5.05212 6.38976 4.01212C6.38976 2.94545 5.52976 2.08545 4.46309 2.08545C3.40309 2.08545 2.54309 2.94545 2.54309 4.01212C2.54309 5.05212 3.36309 5.89878 4.39642 5.93212Z",
    fill: "#CE6300"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.46989 9.31877C4.46989 9.96544 4.60989 10.5788 4.86323 11.1321C3.92323 11.2321 2.94323 11.0321 2.22323 10.5588C1.16989 9.85877 1.16989 8.71877 2.22323 8.01877C2.93656 7.53877 3.94323 7.34544 4.88989 7.4521C4.61656 8.0121 4.46989 8.64544 4.46989 9.31877Z",
    fill: "#CE6300"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18322 11.3321C8.12989 11.3254 8.06989 11.3254 8.00989 11.3321C6.78322 11.2921 5.80322 10.2854 5.80322 9.04544C5.80989 7.77877 6.82989 6.75211 8.10322 6.75211C9.36989 6.75211 10.3966 7.77877 10.3966 9.04544C10.3899 10.2854 9.41656 11.2921 8.18322 11.3321Z",
    fill: "#CE6300"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01647 12.7121C5.00981 13.3854 5.00981 14.4921 6.01647 15.1588C7.16314 15.9254 9.04314 15.9254 10.1898 15.1588C11.1965 14.4854 11.1965 13.3788 10.1898 12.7121C9.04981 11.9454 7.16981 11.9454 6.01647 12.7121Z",
    fill: "#CE6300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.a21d1216b8877adcead1f194d07742a2.svg";
export { ForwardRef as ReactComponent };